import Box from "@mui/material/Box";
import { CustomDrawer } from "app/components/Drawer";
import Topbar from "app/containers/Home/components/topbar";
import React from "react";
import { Outlet } from "react-router-dom";

import { useStyles } from "./styles";

const InternalLayout = () => {
  const styles = useStyles();

  return (
    <Box className={styles.container}>
      <Box className={styles.contentWrapper}>
        <Box className={styles.topbarWrapper}>
          <Topbar />
        </Box>

        <Box className={styles.content}>
          <Outlet />
        </Box>
      </Box>

      <CustomDrawer />
    </Box>
  );
};

export default InternalLayout;
